import { MY_NUTRITION_CARD_BACKGROUND } from '@/constants/images';
import { useBootup } from '@/hooks/useBootup';
import { EventTracker } from '@/utils';
import { cn } from '@/utils/styles';
import { ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface MyNutritionCardProps {
  title?: string;
  description?: string;
  imagePath?: string;
}

export const MyNutritionCard = ({
  title = 'Follow your nutrition recommendations to improve your health',
  description = 'Go to Nutrition',
}: MyNutritionCardProps) => {
  const navigate = useNavigate();
  const { bootupState } = useBootup();
  const isOHI = bootupState?.kitDetailsData?.kitType === 'OHI';
  const cardBgImg = () => {
    return isOHI
      ? 'https://res.cloudinary.com/dttltpafi/image/upload/v1738133773/ImageBanner_hyn3jm.png'
      : MY_NUTRITION_CARD_BACKGROUND;
  };
  return (
    <div
      className={cn(
        'relative',
        'h-64 w-full',
        'px-8 py-8',
        'rounded-xl',
        'border border-white/20',
        'flex justify-between',
        'overflow-hidden',
        !isOHI && 'bg-gradient-to-l from-[#C8E5FF] via-[#D5F0FF] to-[#D5F0FF]',
      )}
      onClick={() => {
        EventTracker.trackEvent('home', 'home_nutritionSummary_nutritionCTA');
        navigate('/nutrition');
      }}
      role="button"
      tabIndex={0}
      data-testid="home-nutritionCard"
    >
      <div className="flex flex-col gap-2 z-10" data-testid="home-nutritionCard-content">
        <h2 className="typography-h4 md:typography-d2 text-primary max-w-[33rem]" data-testid="home-nutritionCard-title">{title}</h2>
        <p className="typography-body text-primary/70 max-w-80" data-testid="home-nutritionCard-description">
          {description}{' '}
          <ChevronRight
            size={16}
            aria-hidden
            className="inline-block ml-1 cursor-pointer"
          />
        </p>
      </div>

      <div
        className={cn(
          'absolute',
          isOHI ? 'inset-0 w-full' : 'right-0 top-0 h-full',
        )}
        data-testid="home-nutritionCard-imageContainer"
      >
        <img
          src={cardBgImg()}
          alt="Nutrition illustration"
          className={cn(
            'h-full',
            isOHI
              ? 'w-full object-cover'
              : 'w-auto object-cover relative left-36',
          )}
          data-testid="home-nutritionCard-image"
        />
      </div>
    </div>
  );
};
